<template>
    <v-app>
        <Toolbar title="Device Cloud Log"/>
        <v-content>
            <v-layout row>
                <v-flex xs12 sm12 offset-sm0>
                    <v-card>
                        <v-card-title primary-title>
                            <v-btn @click="$router.push({path: '/device/' + groupId + '/' + deviceId})">
                                <v-icon dark>arrow_back</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <div>
                                <div class="headline">{{ deviceId }}</div>
                                <span class="grey--text">Group: {{ groupName }}</span>
                            </div>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>

            <LogPanel :serial="deviceId"/>
        </v-content>
    </v-app>
</template>

<script>
    import {mapActions} from 'vuex'
    import Toolbar from '../components/Toolbar'
    import LogPanel from '../components/LogPanel'

    export default {
        name: "Log",
        components: {Toolbar, LogPanel },
        mounted() {
            if (this.deviceId === undefined || this.deviceId === 'undefined') {
                this.$router.push({path: '/groups'})
            }
            this.fetchAll()
        },
        computed: {
            groupId: function () {
                return this.$route.params['group_id']
            },
            groupName: function () {
                let group = this.$store.state.groups[this.groupId]

                if (group !== undefined) {
                    return group.name
                }
                return ''
            },
            deviceId: function () {
                return this.$route.params['device_id']
            }
        },
        methods: {
            ...mapActions(['isUserLoggedIn', 'fetchAll'])
        }
    }
</script>

<style scoped>

</style>
